/**
 * The stat panel type and the settings it draws from.
 */
import { ANALYTICS_COLUMN_TYPES, normalizeAnalyticsColumnType } from '../../../cirra/analyticsColumnTypes.js';

const stat = {
  names: [{ id: 'stat', label: 'Stat', phrase: 'a stat tile', guide: 'stat.md', advanced: true, pinnedLayout: { w: 3, h: 3 }, toolSummary: 'single KPI number tile, no target — height pinned at 3 rows, width adjustable 2-12 columns', promptSummary: 'one big KPI number in a tile, with no target to measure it against — fixed height, adjustable width' }],
  block: 'stat',
  /* Stat tile. The note under the number is the one display field meant to be removed, so it is the
     one that reads '' as a deliberate clear. */
  fields: {
    valueKey: { kind: 'string', required: true },
    /* Sibling of valueKey from the ONE shared value-type vocabulary (analyticsColumnTypes) — the same
       list the table's column types use. It decides both how the number is formatted and what an
       absent value means (count → 0, percent/rank → —), so the tile never depends on the transform
       remembering to guard a null. */
    valueType: { kind: 'enum', values: ANALYTICS_COLUMN_TYPES, normalize: normalizeAnalyticsColumnType, clearable: true },
    noteKey: { kind: 'string', clearable: true }
  },
  stateSummary: ({ block }) => (block.valueKey ? `stat: value ${block.valueKey}${block.noteKey ? `, note ${block.noteKey}` : ''}` : ''),
  toolSchema: {
    type: ['object', 'null'],
    additionalProperties: false,
    required: ['valueKey'],
    description: 'Stat tile mapping (displayType "stat"): the FIRST data row feeds the tile — the big number plus an optional note under it (the panel name is the tile\'s label; there is no separate label). Have the transform return exactly one row (e.g. [{ value: 68000, note: "vs. last month" }]). Columns named value/note auto-assign when keys are omitted.',
    properties: {
      valueKey: { type: 'string', description: 'Column for the big number.' },
      valueType: { type: 'string', enum: ANALYTICS_COLUMN_TYPES, description: 'What kind of value it is, from the shared type vocabulary: number, percent, currency, duration, rank, string. This is how the tile formats it AND what it shows when a window has no data — a count reads 0, a percent or rank reads "—". Emit raw numbers from SQL/transform and declare the type here; never format the value into a string yourself.' },
      noteKey: { type: 'string', description: 'Optional column for the small note below the number.' }
    }
  }
};

export default stat;
